import { defineComponent } from "vue";
import { Container } from "aurelia-dependency-injection";
import { useVuelidate } from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";

import { HospiceReferral } from "../../../../../../../resources-vue/vue-models/hospice-referral";
import { Patient } from "../../../../../../../resources-vue/vue-models/referral-patient";
import { PreadmissionNote } from "../../../../../../../resources-vue/vue-models/preadmission-note-model";
import { ToastrService } from "../../../../../../../services/toastr.service";
import { ReferralService } from "../../../../../../../services/referral-service";
import { TemplateService } from "../../../../../../../services/template-service";
import { ApplicationEnum } from "../../../../../../../enums/enums";
import { Template } from "../../../../../../../models/template";

import NewTypeahead from "../../../../../../../resources-vue/vue-custom-elements/NewTypeahead/NewTypeahead.vue";
import FormSection from "../../../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";

export default defineComponent({
    components: {
        NewTypeahead,
        FormSection
    },

    props: {
        note: {
            type: Object,
            default: null
        },
        referralId: {
            type: String,
            default: ""
        },
        isReadOnly: {
            type: Boolean,
            default: false
        },
        resetList: {
            type: Function
        },
        showNoteForm: {
            type: Boolean,
            default: false
        },
        application: {
            type: Number
        },
        referral: {
            type: HospiceReferral || Patient
        },
        closeNoteFormProp: {
            type: Function
        }
    },
    data(vm) {
        return {
            _toastrService: null,
            _templateService: null,
            _referralService: null,
            selectedTemplate: null,
            newNote: new PreadmissionNote(),
            showTemplateTypeahead: false,
            v$: useVuelidate()
        };
    },

    created() {
        this._toastrService = Container.instance.get(ToastrService);
        this._referralService = Container.instance.get(ReferralService);
        this._templateService = Container.instance.get(TemplateService);
    },
    mounted() {
        this.showTemplateTypeahead = true;
        if (!this.note) {
            return;
        }
        this.note.title = this.note.title;
        this.note.notes = this.note.notes;
    },
    methods: {
        closeNoteForm() {
            this.closeNoteFormProp();
            this.v$.$reset();
        }
    }
});
